<template>
  <fade-in>
    <div class="header-container">
      <h1>{{ lang[activeLang]['ONLINE FORM TO REQUEST LEGAL ASSISTANCE'] }}</h1>
      <p>
        {{
          lang[activeLang][
            'The ACLU of Pennsylvania is the state’s oldest and largest civil rights organization. We are a non-partisan organization funded exclusively by the generous donations of our supporters. Our mission is to protect, defend and extend the civil rights and civil liberties of all people in Pennsylvania.'
          ]
        }}
      </p>
      <p>
        <em>* </em> {{ lang[activeLang]['Indicates the required fields.'] }}
      </p>
    </div>
  </fade-in>
</template>

<script>
import FadeIn from './FadeIn.vue'

export default {
  name: 'FormHeader',
  components: {
    FadeIn
  },
  props: {
    activeLang: {
      type: String,
      default: 'English'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header-container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
}

.spacer {
  width: 2%;
}

.header-logo {
  width: 64px;
  height: 64px;
  color: black;
}

h1 {
  text-align: left;
  font-size: 32px;
}

p {
  text-align: left;
}

em {
  color: rgb(214, 88, 88);
}
</style>
